export const selectCategoriesData = state => state.categories.data

export const selectCategoriesLoadingState = state => state.categories.loading

export const selectCategoriesError = state => state.categories.error
